import { createStore } from 'vuex';

export const store = createStore({
    state: {
        loggedUser: null,
    },
    mutations: {
        setLoggedUser (state, username) {
            state.loggedUser = username;
        }
    }
});